"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLayoutController = exports.LayoutControlProvider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const noop = () => null;
const LayoutController = (0, react_1.createContext)({
    chatVisible: '',
    toggleFullScreen: noop,
    hideChat: noop,
    popUpText: '',
    publishAppNotification: noop,
    memberListVisible: '',
    hideMemberList: noop,
    showMemberList: noop,
    upgradePanelVisible: false,
    showUpgradePanel: noop,
    hideUpgradePanel: noop,
});
const LayoutControlProvider = ({ children }) => {
    const [chatVisible, setChatVisibility] = (0, react_1.useState)('');
    const [popUpText, setPopUpText] = (0, react_1.useState)('');
    const [memberListVisible, setShowMembers] = (0, react_1.useState)('');
    const [upgradePanelVisible, setUpgradePanelVisible] = (0, react_1.useState)(false);
    const toggleFullScreen = (0, react_1.useCallback)(() => {
        setChatVisibility((prev) => ['chat-hidden', ''].includes(prev) ? 'chat-visible' : 'chat-hidden');
        setShowMembers('');
    }, []);
    const hideChat = (0, react_1.useCallback)(() => {
        setChatVisibility('chat-hidden');
        setShowMembers('hide-members');
    }, []);
    const showUpgradePanel = (0, react_1.useCallback)(() => {
        setShowMembers('hide-members');
        setUpgradePanelVisible(true);
    }, []);
    const hideUpgradePanel = (0, react_1.useCallback)(() => {
        setUpgradePanelVisible(false);
    }, []);
    const hideMemberList = (0, react_1.useCallback)(() => {
        setShowMembers('hide-members');
    }, []);
    const showMemberList = (0, react_1.useCallback)(() => {
        setShowMembers('show-members');
    }, []);
    const publishAppNotification = (0, react_1.useCallback)((text) => {
        if (!text)
            return;
        setPopUpText(text);
        setTimeout(() => {
            setPopUpText('');
        }, 3000);
    }, []);
    return (0, jsx_runtime_1.jsx)(LayoutController.Provider, { value: {
            chatVisible,
            hideChat,
            toggleFullScreen,
            popUpText,
            publishAppNotification,
            memberListVisible,
            hideMemberList,
            showMemberList,
            upgradePanelVisible,
            showUpgradePanel,
            hideUpgradePanel,
        }, children: children });
};
exports.LayoutControlProvider = LayoutControlProvider;
const useLayoutController = () => (0, react_1.useContext)(LayoutController);
exports.useLayoutController = useLayoutController;
